var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.relatedDashboards.length > 1)?_c('v-btn-toggle',{attrs:{"group":"","dense":"","color":"primary"}},_vm._l((_vm.relatedDashboards),function(dash){return _c('v-btn',{key:dash.id,attrs:{"to":{ name: 'DashboardShow', params: { dashId: dash.id } }}},[_vm._v(" "+_vm._s(_vm.dashName(dash.name))+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }